var exports = {
  "kL": "UploadSlotInfo.module__container___SFVWR2",
  "wx": "UploadSlotInfo.module__header___SFVWR2",
  "DD": "UploadSlotInfo.module__title___SFVWR2",
  "M1": "UploadSlotInfo.module__stats___SFVWR2",
  "h_": "UploadSlotInfo.module__description___SFVWR2",
  "Kk": "UploadSlotInfo.module__icon___SFVWR2",
  "wF": "UploadSlotInfo.module__uploadButtonDesktop___SFVWR2",
  "Ig": "UploadSlotInfo.module__uploadButtonMobile___SFVWR2",
};

module.exports = exports;
